export const getNameText = object => object.name || '';
